"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvePrefixUrlConditionally = exports.getHostBaseUrl = exports.isSupportLocalStorage = void 0;
var isSupportLocalStorage = function () {
    try {
        if (window.Storage && window.localStorage && window.localStorage instanceof Storage) {
            return true;
        }
        else {
            return false;
        }
    }
    catch (error) {
        return false;
    }
};
exports.isSupportLocalStorage = isSupportLocalStorage;
var getHostBaseUrl = function () {
    var w = typeof window !== 'undefined' ? window : undefined;
    return ((w === null || w === void 0 ? void 0 : w.location) ? (w.location.protocol + '//' + w.location.host) : undefined);
};
exports.getHostBaseUrl = getHostBaseUrl;
var getApiPrefixUrlForCrossOrigin = function () {
    var w = typeof window !== 'undefined' ? window : undefined;
    var prefix = (w === null || w === void 0 ? void 0 : w.IS_BUILD_TIME_CROSS_ORIGIN_PREFIX_URL) === 'true' && (w === null || w === void 0 ? void 0 : w.PREFIX_URL);
    return prefix && prefix.replace(/\/+$/, '');
};
/**
 * Resolves the full URL by conditionally adding a prefix for cross-origin scenarios.
 *
 * This function prepends the PREFIX_URL to the given path when running in
 * cross-origin environments (e.g., localhost development or GitLab review links). No need
 * to prepends prefix if running in same-origin (production) environment. If required it can
 * be extended.
 *
 * @param {string} path - The relative or absolute path to resolve
 * @returns {string} The full URL with prefix if cross-origin, otherwise the original path
 *
 * @example
 * // Cross-origin (localhost): PREFIX_URL = 'https://api.example.com'
 * resolvePrefixUrlIfCrossOrigin('/rest/api/search')
 * // Returns: 'https://api.example.com/rest/api/search'
 */
var resolvePrefixUrlConditionally = function (path) {
    if (!path || typeof path !== 'string' || /^https?:\/\//.test(path))
        return path;
    var baseClean = getApiPrefixUrlForCrossOrigin();
    if (!baseClean)
        return path;
    var pathClean = path.replace(/^\/+/, '');
    return "".concat(baseClean, "/").concat(pathClean);
};
exports.resolvePrefixUrlConditionally = resolvePrefixUrlConditionally;
